module.exports = __webpack_public_path__ + "fonts/64721cc.ttf";